/** 自定义表单 */
import React, { FC, ReactNode, isValidElement } from 'react';
import { ProCol } from '../antd';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormOtherProps extends BaseSearchFormItemProps {
  /** 内容 */
  // render?: ReactNode;
}
/** 其他表单 */
export const SearchFormOther: FC<SearchFormOtherProps> = props => {
  const { span, offset, order, pull, push, render, isDetail, hidden } = props;
  const renderChild = () => {
    const renderHTML = typeof render === 'function' ? render() : render;
    if (isValidElement(renderHTML)) {
      // @ts-ignore
      return React.cloneElement(renderHTML, { isDetail });
    }
    return renderHTML;
  };
  return (
    <ProCol span={span} offset={offset} order={order} pull={pull} push={push} style={hidden ? { display: 'none', } : undefined}>
      {renderChild()}
    </ProCol>
  );
};

SearchFormOther.displayName = SearchFormItemEnum.SearchFormOther;

export default SearchFormOther;
